import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { becauseYouShoppedList as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    checkShouldUseCarousel: (activeMQ) => (['XS', 'S'].includes(activeMQ)),
  },
  foryou: {
    checkShouldUseCarousel: () => false,
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
